import Navigation from './navigation-view';

export default Navigation;
